import { persist } from 'zustand/middleware';
import { createStore } from 'zustand/vanilla';

const DISMISSAL_DURATION_DAYS = 90;

export type DismissedReferralCode = {
  referralCode: string;
  dismissedAt: number;
};

export type ReferralStore = {
  dismissedReferralCodes: DismissedReferralCode[];
  referrerCode?: string;

  // Actions
  dismissReferralCode: (referralCode: string) => void;
  hasDismissedReferralCode: (referralCode: string) => boolean;
  setReferrerCode: (referrerCode?: string) => void;
  clearReferrerCode: () => void;
  reset: () => void;
};

export const referralStore = createStore<ReferralStore>()(
  persist(
    (set, get) => ({
      dismissedReferralCodes: [],
      referrerCode: undefined,

      dismissReferralCode: (referralCode) =>
        set((state) => {
          const filteredCodes = state.dismissedReferralCodes.filter((item) => item.referralCode !== referralCode);

          return {
            dismissedReferralCodes: [
              ...filteredCodes,
              {
                referralCode,
                dismissedAt: new Date().getTime(),
              },
            ],
          };
        }),

      hasDismissedReferralCode: (referralCode) => {
        const { dismissedReferralCodes } = get();
        const now = new Date().getTime();
        const dismissedCode = dismissedReferralCodes.find((item) => item.referralCode === referralCode);

        return (
          dismissedCode !== undefined && now - dismissedCode.dismissedAt < DISMISSAL_DURATION_DAYS * 24 * 60 * 60 * 1000
        );
      },

      setReferrerCode: (referrerCode) => set({ referrerCode }),
      clearReferrerCode: () => set({ referrerCode: undefined }),

      reset: () =>
        set({
          dismissedReferralCodes: [],
          referrerCode: undefined,
        }),
    }),
    { name: 'referralStore' },
  ),
);

// Selectors
export function dismissReferralCodeSelector(state: ReferralStore) {
  return state.dismissReferralCode;
}

export function hasDismissedReferralCodeSelector(state: ReferralStore) {
  return state.hasDismissedReferralCode;
}

export function setReferrerCodeSelector(state: ReferralStore) {
  return state.setReferrerCode;
}

export function clearReferrerCodeSelector(state: ReferralStore) {
  return state.clearReferrerCode;
}

export function referrerCodeSelector(state: ReferralStore) {
  return state.referrerCode;
}
